// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recommendedFriends {
  padding: 16px;
  background-color: var(--background);
}

.section-header {
  margin-bottom: 16px;
}

.section-header h2 {
  font-size: 20px;
  font-weight: bold;
  color: var(--secondary-text-consistent);
}

.recommendations-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recommendation-card {
  display: flex;
  padding: 12px;
  background-color: var(--background-consistent);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.user-image-container {
  margin-right: 12px;
}

.user-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.user-info {
  flex: 1 1;
}

.user-info h3 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
}

.mutual-friends {
  display: flex;
  align-items: center;
  margin: 8px 0;
}

.mutual-friends-avatars {
  display: flex;
  margin-right: 8px;
}

.mutual-friend-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid var(--background-consistent);
  object-fit: cover;
  margin-right: -8px;
  background-color: #ddd;
}

.mutual-friend-avatar:last-child {
  margin-right: 8px;
}

.mutual-count {
  font-size: 14px;
  color: #65676B;
}

.action-buttons {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  justify-content: space-around;
}

.add-friend-btn, .remove-btn {
  padding: 12px 64px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.add-friend-btn {
  background-color: var(--theme-consistent);
  color: var(--secondary-text-consistent);
}

.add-friend-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.empty-state {
  color: var(--text-primary);
  font-size: 1.4rem;
  text-align: center;
}

/* .remove-btn {
  background-color: #E4E6EB;
  color: #050505;
} */

@media screen and (min-width: 768px) {
  .recommendation-card {
    padding: 16px;
  }

  .user-avatar {
    width: 80px;
    height: 80px;
  }

  .user-info h3 {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/RecommendedFriends.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8CAA8C;EAC9C,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".recommendedFriends {\n  padding: 16px;\n  background-color: var(--background);\n}\n\n.section-header {\n  margin-bottom: 16px;\n}\n\n.section-header h2 {\n  font-size: 20px;\n  font-weight: bold;\n  color: var(--secondary-text-consistent);\n}\n\n.recommendations-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.recommendation-card {\n  display: flex;\n  padding: 12px;\n  background-color: var(--background-consistent);\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.user-image-container {\n  margin-right: 12px;\n}\n\n.user-avatar {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.user-info {\n  flex: 1;\n}\n\n.user-info h3 {\n  margin: 0 0 4px 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.mutual-friends {\n  display: flex;\n  align-items: center;\n  margin: 8px 0;\n}\n\n.mutual-friends-avatars {\n  display: flex;\n  margin-right: 8px;\n}\n\n.mutual-friend-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 2px solid var(--background-consistent);\n  object-fit: cover;\n  margin-right: -8px;\n  background-color: #ddd;\n}\n\n.mutual-friend-avatar:last-child {\n  margin-right: 8px;\n}\n\n.mutual-count {\n  font-size: 14px;\n  color: #65676B;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  justify-content: space-around;\n}\n\n.add-friend-btn, .remove-btn {\n  padding: 12px 64px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n}\n\n.add-friend-btn {\n  background-color: var(--theme-consistent);\n  color: var(--secondary-text-consistent);\n}\n\n.add-friend-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.empty-state {\n  color: var(--text-primary);\n  font-size: 1.4rem;\n  text-align: center;\n}\n\n/* .remove-btn {\n  background-color: #E4E6EB;\n  color: #050505;\n} */\n\n@media screen and (min-width: 768px) {\n  .recommendation-card {\n    padding: 16px;\n  }\n\n  .user-avatar {\n    width: 80px;\n    height: 80px;\n  }\n\n  .user-info h3 {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
